import { toArray as t } from "../../../../utils/helpers.js";
const m = (o, n = "{{numOptions}} selected") => {
  const r = t(o);
  if (!r.length)
    return "";
  const l = n == null ? void 0 : n.replace(
    "{{numOptions}}",
    r.length.toString()
  );
  return r.length === 1 ? r[0].label : l;
};
export {
  m as composeRichSelectDescriptor
};
